export const dataValidators = [
  {
    name: "Satoshi",
    addressWallet: "0xc1cA59e75069C5236E403829fA36fFEf81F1305e",
    commission: "2",
    sizePool: 500000,
    flagFeatured: true,
  },
  {
    name: "Joshua Kahn",
    addressWallet: "0xf19bDBc8dF1C299a2eB13A680fdF4E9E75c1D36E",
    commission: "1",
    sizePool: 230000,
    flagFeatured: true,
  },
  {
    name: "J.Grover",
    addressWallet: "0x6a541f2c597c557d97cDDF64F56FF12F1f29102f",
    commission: "1",
    sizePool: 300000,
    flagFeatured: false,
  },
  {
    name: "Hector",
    addressWallet: "0xcF8c256c5bc28643c04ebDCBBC60e17DE801b99B",
    commission: "3",
    sizePool: 7000000,
    flagFeatured: false,
  },
];
